import { FormLabel } from '../../../../primitives/index.js'
import { capitalize } from '@tunasong/models'
import type { FC } from 'react'
import type { ListFormField } from '../../../lib/form-field.js'
import type { FormComponentGroupComponentProps } from '../form-component.js'
import styles from '../form-box.module.css'
import FormControl from '../form-control.js'

export interface ListSchemaFieldProps extends FormComponentGroupComponentProps<ListFormField> {}

/** @note not fully implemented */
export const ListSchemaField: FC<ListSchemaFieldProps> = props => {
  const { name, spec, errors, ...restProps } = props
  const label = capitalize(spec.metadata?.label ?? name)

  /** @todo implement this */
  const list: unknown[] = []
  return (
    <div className={styles.formBox}>
      <FormLabel className={styles.formLabel}>{label}</FormLabel>

      {list.map((item, index) => (
        <FormControl
          key={index}
          name={`${name}[${index}]`}
          errors={errors}
          formField={spec.valueType}
          defaultValue={item}
          {...restProps}
        />
      ))}
      {/* <Button onClick={addElement}>Add</Button> */}
    </div>
  )
}

export default ListSchemaField
